// src/context/TimeFilterContext.js
import React, { createContext, useContext, useState } from "react";

const TimeFilterContext = createContext();

export function TimeFilterProvider({ children }) {
    const [timeFilter, setTimeFilter] = useState("weekly");
    const [customRange, setCustomRange] = useState({ start: "", end: "" });
    const [planFilter, setPlanFilter] = useState(null);
    const [availablePlans, setAvailablePlans] = useState([]);

    const handleCustomRangeChange = (type, value) => {
        setCustomRange((prev) => {
            const newRange = { ...prev, [type]: value };
            // Ensure end date isn't before start date if both exist
            if (newRange.start && newRange.end && new Date(newRange.start) > new Date(newRange.end)) {
                // If setting start date and it's after end date, clear end date
                if (type === 'start') return { ...newRange, end: "" };
                // If setting end date and it's before start date, clear start date (or reject, but clearing is safer UX)
                if (type === 'end') return { ...newRange, start: "" };
            }
            return newRange;
        });
    };

    return (
        <TimeFilterContext.Provider
            value={{
                timeFilter,
                setTimeFilter,
                customRange,
                setCustomRange,
                handleCustomRangeChange,
                planFilter,
                setPlanFilter,
                availablePlans,
                setAvailablePlans,
            }}
        >
            {children}
        </TimeFilterContext.Provider>
    );
}

export function useTimeFilter() {
    const context = useContext(TimeFilterContext);
    if (!context) {
        throw new Error("useTimeFilter must be used within a TimeFilterProvider");
    }
    return context;
}
